import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">Terms and Conditions</h1>
      
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">1. Acceptance of Terms</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          By accessing or using GamePreBattle, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">2. Eligibility</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          You must be at least 18 years old to use GamePreBattle. By using our services, you represent and warrant that you meet the age requirement and have the legal capacity to enter into these terms.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">3. Account Registration</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          To use certain features of GamePreBattle, you must register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">4. Prediction Rules</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          GamePreBattle allows you to make predictions on various sports events. All predictions are subject to our prediction rules, which can be found in the Prediction Rules section. We reserve the right to modify these rules at any time.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">5. Virtual Currency</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          GamePreBattle uses virtual coins for predictions. These coins have no real-world monetary value and cannot be exchanged for cash. We reserve the right to modify the value, availability, or use of these coins at our discretion.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">6. User Conduct</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          You agree not to use GamePreBattle for any unlawful purpose or in any way that could damage, disable, overburden, or impair our services. This includes but is not limited to: cheating, hacking, creating multiple accounts, or engaging in any form of harassment.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">7. Termination</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          We reserve the right to suspend or terminate your account at any time for any reason, including but not limited to violation of these Terms and Conditions.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">8. Changes to Terms</h2>
        <p className="mb-4 text-gray-700 dark:text-gray-300">
          We may modify these Terms and Conditions at any time. Your continued use of GamePreBattle after any such changes constitutes your acceptance of the new terms.
        </p>
        
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">9. Contact Information</h2>
        <p className="text-gray-700 dark:text-gray-300">
          If you have any questions about these Terms and Conditions, please contact us through our Support page.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions; 